export default function formatUsername(username: string): string {
  return `@${username}`;
}
